<template>
  <section class="new">
    <div class="new-type">
      <div class="new-type__item" :class="{ active: getNewType === 'events' }" @click="setNewType('events')">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 22 22">
          <path
            d="M16 20H2a2 2 0 01-2-2V4a2 2 0 012-2h2V0h2v2h6V0h2v2h2a2 2 0 012 2v14a2 2 0 01-2 2zM2 8v10h14V8H2zm0-4v2h14V4H2zm6 12.414l-3.707-3.707 1.414-1.414L8 13.586l4.293-4.293 1.414 1.414L8 16.413v.001z"
          />
        </svg>
        <p>Мероприятие</p>
      </div>
      <div class="new-type__item" :class="{ active: getNewType === 'places' }" @click="setNewType('places')">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 22 22">
          <path
            d="M5.5 20.5a1 1 0 01-1-1v-15a1 1 0 011-1h6.38a1 1 0 01.9.55l.72 1.45h5a1 1 0 011 1v8a1 1 0 01-1 1h-5.39a1 1 0 01-.89-.55l-.72-1.45h-5v6a1 1 0 01-1 1zm1-15v6h6l1 2h4v-6h-5l-1-2h-5z"
          />
        </svg>
        <p>Место</p>
      </div>
      <div
        class="new-type__item disable"
        :class="{ active: getNewType === 'article' }"
        @click="setNewType('article')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 22 22">
          <path d="M15 19H3v-2h12v2zm6-4H3v-2h18v2zm-6-4H3V9h12v2zm6-4H3V5h18v2z" />
        </svg>
        <p>Статья</p>
      </div>
    </div>

    <new-event v-if="getNewType === 'events'" />
    <new-place v-if="getNewType === 'places'" />

    <div class="new-close" @click="changeState('workplace')">
      <img src="@/assets/images/icons/icon_close.svg" />
    </div>
  </section>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFlag } from '@fortawesome/free-regular-svg-icons';
// import NewEvent from './NewEvent'
// import NewPlace from './NewPlace'

library.add(faFlag);

export default {
  name: 'Workplace',
  computed: {
    getNewType() {
      return this.$store.getters.getNewType;
    }
  },
  components: {
    NewEvent: () => import('./NewEvent'),
    NewPlace: () => import('./NewPlace'),
  },
  methods: {
    setNewType(type) {
      this.$store.dispatch('setNewType', type)
    },
    changeState(element) {
      this.$store.dispatch('changeState', { element });
    },
  },
};
</script>
